// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_proxy.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppEntitlementView } from "./app_entitlement";
import { AppEntitlementExpandMask } from "./app_entitlement";
import { Facets } from "../../search/v1/facet";
import { AncestralBinding } from "./app_entitlement";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementProxyRequest
 */
export interface GetAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementProxyResponse
 */
export interface GetAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1;
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxy
 */
export interface AppEntitlementProxy {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool system_builtin = 8;
     */
    systemBuiltin: boolean;
    /**
     * If true, the binding doesn't not exist yet and is from the list of the entitlements from the parent app.
     * typically the IdP that handles provisioning for the app instead of C1s connector.
     *
     * @generated from protobuf field: optional bool implicit = 9;
     */
    implicit?: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp disabled_at = 10;
     */
    disabledAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyView
 */
export interface AppEntitlementProxyView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1;
     */
    appProxyEntitlement?: AppEntitlementProxy;
    /**
     * @generated from protobuf field: string src_app_path = 2;
     */
    srcAppPath: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_path = 3;
     */
    srcAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string dst_app_path = 4;
     */
    dstAppPath: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_path = 5;
     */
    dstAppEntitlementPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyExpandMask
 */
export interface AppEntitlementProxyExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementProxyRequest
 */
export interface CreateAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementProxyResponse
 */
export interface CreateAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1;
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementProxyRequest
 */
export interface DeleteAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyWithCreateDestination
 */
export interface AppEntitlementProxyWithCreateDestination {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_resource_name = 4;
     */
    dstResourceName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.BindingWithNewOrExisting
 */
export interface BindingWithNewOrExisting {
    /**
     * @generated from protobuf oneof: binding
     */
    binding: {
        oneofKind: "appProxyEntitlement";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1;
         */
        appProxyEntitlement: AppEntitlementProxy;
    } | {
        oneofKind: "appProxyEntitlementCreate";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyWithCreateDestination app_proxy_entitlement_create = 2;
         */
        appProxyEntitlementCreate: AppEntitlementProxyWithCreateDestination;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest
 */
export interface BulkCreateAppEntitlementProxyWithDestinationsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.BindingWithNewOrExisting bindings = 1;
     */
    bindings: BindingWithNewOrExisting[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse
 */
export interface BulkCreateAppEntitlementProxyWithDestinationsResponse {
    /**
     * Map of app proxy entitlement ID to errors. The format of the id is <src_app_id>:<src_app_entitlement_id>:<dst_app_id>:<dst_app_entitlement_id>
     *
     * @generated from protobuf field: map<string, string> app_entitlement_proxy_bindings_error_map = 1;
     */
    appEntitlementProxyBindingsErrorMap: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AncestralBinding list = 2;
     */
    list: AncestralBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementProxySourcesRequest
 */
export interface ListAppEntitlementProxySourcesRequest {
    /**
     * @generated from protobuf field: string dst_app_id = 1;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 2;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest
 */
export interface ListAppEntitlementProxyDestinationsRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsProxyResponse
 */
export interface ListAppEntitlementsProxyResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementProxyView list = 1;
     */
    list: AppEntitlementProxyView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRef
 */
export interface SearchAppEntitlementProxyBindingsRef {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest
 */
export interface SearchAppEntitlementProxyBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 5;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 6;
     */
    expandMask?: AppEntitlementProxyExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ProxyBindingDirection directions = 7;
     */
    directions: ProxyBindingDirection[];
    /**
     * If true, search will return the entitlements from the parent app as
     * implicit bindings.
     *
     * @generated from protobuf field: optional bool implicit = 8;
     */
    implicit?: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse
 */
export interface SearchAppEntitlementProxyBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementProxyView list = 1;
     */
    list: AppEntitlementProxyView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetChildEntitlementsRequest
 */
export interface GetChildEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAncestorEntitlementsRequest
 */
export interface GetAncestorEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.EntitlementChainResponse
 */
export interface EntitlementChainResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementProxyResponse
 */
export interface DeleteAppEntitlementProxyResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.EnableAppEntitlementProxyRequest
 */
export interface EnableAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.EnableAppEntitlementProxyResponse
 */
export interface EnableAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1;
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DisableAppEntitlementProxyRequest
 */
export interface DisableAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1;
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2;
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3;
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4;
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.DisableAppEntitlementProxyResponse
 */
export interface DisableAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1;
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf enum c1.api.app.v1.ProxyBindingDirection
 */
export enum ProxyBindingDirection {
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_INBOUND = 1;
     */
    INBOUND = 1,
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_OUTBOUND = 2;
     */
    OUTBOUND = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementProxyRequest$Type extends MessageType<GetAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementProxyRequest
 */
export const GetAppEntitlementProxyRequest = new GetAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementProxyResponse$Type extends MessageType<GetAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementProxyResponse
 */
export const GetAppEntitlementProxyResponse = new GetAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxy$Type extends MessageType<AppEntitlementProxy> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxy", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "implicit", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "disabled_at", kind: "message", T: () => Timestamp }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Entitlement Proxy Binding" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxy
 */
export const AppEntitlementProxy = new AppEntitlementProxy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyView$Type extends MessageType<AppEntitlementProxyView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyView", [
            { no: 1, name: "app_proxy_entitlement", kind: "message", T: () => AppEntitlementProxy },
            { no: 2, name: "src_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dst_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dst_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyView
 */
export const AppEntitlementProxyView = new AppEntitlementProxyView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyExpandMask$Type extends MessageType<AppEntitlementProxyExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "src_app_id", "src_app_entitlement_id", "dst_app_id", "dst_app_entitlement_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyExpandMask
 */
export const AppEntitlementProxyExpandMask = new AppEntitlementProxyExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementProxyRequest$Type extends MessageType<CreateAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementProxyRequest
 */
export const CreateAppEntitlementProxyRequest = new CreateAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementProxyResponse$Type extends MessageType<CreateAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementProxyResponse
 */
export const CreateAppEntitlementProxyResponse = new CreateAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementProxyRequest$Type extends MessageType<DeleteAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementProxyRequest
 */
export const DeleteAppEntitlementProxyRequest = new DeleteAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyWithCreateDestination$Type extends MessageType<AppEntitlementProxyWithCreateDestination> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyWithCreateDestination", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyWithCreateDestination
 */
export const AppEntitlementProxyWithCreateDestination = new AppEntitlementProxyWithCreateDestination$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingWithNewOrExisting$Type extends MessageType<BindingWithNewOrExisting> {
    constructor() {
        super("c1.api.app.v1.BindingWithNewOrExisting", [
            { no: 1, name: "app_proxy_entitlement", kind: "message", oneof: "binding", T: () => AppEntitlementProxy },
            { no: 2, name: "app_proxy_entitlement_create", kind: "message", oneof: "binding", T: () => AppEntitlementProxyWithCreateDestination }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BindingWithNewOrExisting
 */
export const BindingWithNewOrExisting = new BindingWithNewOrExisting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkCreateAppEntitlementProxyWithDestinationsRequest$Type extends MessageType<BulkCreateAppEntitlementProxyWithDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BindingWithNewOrExisting, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "300" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest
 */
export const BulkCreateAppEntitlementProxyWithDestinationsRequest = new BulkCreateAppEntitlementProxyWithDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkCreateAppEntitlementProxyWithDestinationsResponse$Type extends MessageType<BulkCreateAppEntitlementProxyWithDestinationsResponse> {
    constructor() {
        super("c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse", [
            { no: 1, name: "app_entitlement_proxy_bindings_error_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AncestralBinding },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse
 */
export const BulkCreateAppEntitlementProxyWithDestinationsResponse = new BulkCreateAppEntitlementProxyWithDestinationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementProxySourcesRequest$Type extends MessageType<ListAppEntitlementProxySourcesRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementProxySourcesRequest", [
            { no: 1, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementProxySourcesRequest
 */
export const ListAppEntitlementProxySourcesRequest = new ListAppEntitlementProxySourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementProxyDestinationsRequest$Type extends MessageType<ListAppEntitlementProxyDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest
 */
export const ListAppEntitlementProxyDestinationsRequest = new ListAppEntitlementProxyDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsProxyResponse$Type extends MessageType<ListAppEntitlementsProxyResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsProxyResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsProxyResponse
 */
export const ListAppEntitlementsProxyResponse = new ListAppEntitlementsProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsRef$Type extends MessageType<SearchAppEntitlementProxyBindingsRef> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsRef", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRef
 */
export const SearchAppEntitlementProxyBindingsRef = new SearchAppEntitlementProxyBindingsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsRequest$Type extends MessageType<SearchAppEntitlementProxyBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask },
            { no: 7, name: "directions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.ProxyBindingDirection", ProxyBindingDirection, "PROXY_BINDING_DIRECTION_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "implicit", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest
 */
export const SearchAppEntitlementProxyBindingsRequest = new SearchAppEntitlementProxyBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsResponse$Type extends MessageType<SearchAppEntitlementProxyBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse
 */
export const SearchAppEntitlementProxyBindingsResponse = new SearchAppEntitlementProxyBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChildEntitlementsRequest$Type extends MessageType<GetChildEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.GetChildEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetChildEntitlementsRequest
 */
export const GetChildEntitlementsRequest = new GetChildEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAncestorEntitlementsRequest$Type extends MessageType<GetAncestorEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAncestorEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAncestorEntitlementsRequest
 */
export const GetAncestorEntitlementsRequest = new GetAncestorEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementChainResponse$Type extends MessageType<EntitlementChainResponse> {
    constructor() {
        super("c1.api.app.v1.EntitlementChainResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EntitlementChainResponse
 */
export const EntitlementChainResponse = new EntitlementChainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementProxyResponse$Type extends MessageType<DeleteAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementProxyResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementProxyResponse
 */
export const DeleteAppEntitlementProxyResponse = new DeleteAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAppEntitlementProxyRequest$Type extends MessageType<EnableAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.EnableAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnableAppEntitlementProxyRequest
 */
export const EnableAppEntitlementProxyRequest = new EnableAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAppEntitlementProxyResponse$Type extends MessageType<EnableAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.EnableAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnableAppEntitlementProxyResponse
 */
export const EnableAppEntitlementProxyResponse = new EnableAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAppEntitlementProxyRequest$Type extends MessageType<DisableAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.DisableAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DisableAppEntitlementProxyRequest
 */
export const DisableAppEntitlementProxyRequest = new DisableAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAppEntitlementProxyResponse$Type extends MessageType<DisableAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.DisableAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DisableAppEntitlementProxyResponse
 */
export const DisableAppEntitlementProxyResponse = new DisableAppEntitlementProxyResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementsProxy
 */
export const AppEntitlementsProxy = new ServiceType("c1.api.app.v1.AppEntitlementsProxy", [
    { name: "ListSources", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementProxySourcesRequest, O: ListAppEntitlementsProxyResponse },
    { name: "ListDestinations", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementProxyDestinationsRequest, O: ListAppEntitlementsProxyResponse },
    { name: "BulkCreateAppEntitlementProxyWithDestinations", options: { "authz.method": { role: "EDITOR" } }, I: BulkCreateAppEntitlementProxyWithDestinationsRequest, O: BulkCreateAppEntitlementProxyWithDestinationsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] } }, I: CreateAppEntitlementProxyRequest, O: CreateAppEntitlementProxyResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] } }, I: DeleteAppEntitlementProxyRequest, O: DeleteAppEntitlementProxyResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] } }, I: GetAppEntitlementProxyRequest, O: GetAppEntitlementProxyResponse },
    { name: "Enable", options: { "authz.method": { role: "EDITOR" } }, I: EnableAppEntitlementProxyRequest, O: EnableAppEntitlementProxyResponse },
    { name: "Disable", options: { "authz.method": { role: "EDITOR" } }, I: DisableAppEntitlementProxyRequest, O: DisableAppEntitlementProxyResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementsProxySearch
 */
export const AppEntitlementsProxySearch = new ServiceType("c1.api.app.v1.AppEntitlementsProxySearch", [
    { name: "SearchAppEntitlementProxyBindings", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementProxyBindingsRequest, O: SearchAppEntitlementProxyBindingsResponse },
    { name: "GetChildEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: GetChildEntitlementsRequest, O: EntitlementChainResponse },
    { name: "GetAncestorEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: GetAncestorEntitlementsRequest, O: EntitlementChainResponse }
]);
